import { useEffect, useState } from "react";
import "./Home.scss";
import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { db } from "../firebase";
import Calendar from "./Calendar";
import { useNavigate } from "react-router-dom";
import { backGroundImage } from "../utils/backGroundImage";

const Home = () => {
  const [displayImages, setDisplayImages] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();
  const [posts, setPosts] = useState([]);
  const [eventReports, setEventReports] = useState([]);
  const [memberExchanges, setMemberExchanges] = useState([]);
  const [others, setOthers] = useState([]);
  const [recommendations, setRecommendations] = useState([]);
  const [allPosts, setAllPosts] = useState([]);
  const [maxChars, setMaxChars] = useState(10);

  useEffect(() => {
    const timer = setTimeout(() => setIsActive(true), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    backGroundImage(setDisplayImages);
  }, []);

  const displayImage = displayImages.length > 0 ? displayImages[0].src : "";

  const queries = [
    {
      query: query(
        collection(db, "posts"),
        where("section.event_report", "==", true),
        orderBy("section.event_report"),
        orderBy("createdAt", "desc"),
        limit(5)
      ),
      setState: setEventReports,
    },
    {
      query: query(
        collection(db, "posts"),
        where("section.member_exchange", "==", true),
        orderBy("section.member_exchange"),
        orderBy("createdAt", "desc"),
        limit(5)
      ),
      setState: setMemberExchanges,
    },
    {
      query: query(
        collection(db, "posts"),
        where("section.recommendations", "==", true),
        orderBy("section.recommendations"),
        orderBy("createdAt", "desc"),
        limit(5)
      ),
      setState: setRecommendations,
    },
    {
      query: query(
        collection(db, "posts"),
        where("section.others", "==", true),
        orderBy("section.others"),
        orderBy("createdAt", "desc"),
        limit(5)
      ),
      setState: setOthers,
    },
  ];

  useEffect(() => {
    const unsubscribeFuncs = queries.map(({ query, setState }) =>
      onSnapshot(query, (snapshot) => {
        setState(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      })
    );

    return () => {
      unsubscribeFuncs.forEach((unsubscribe) => unsubscribe());
    };
  }, []);

  useEffect(() => {
    // 4つの配列を統合して新しい配列を作成
    setAllPosts([
      ...eventReports,
      ...memberExchanges,
      ...recommendations,
      ...others,
    ]);
  }, [eventReports, memberExchanges, recommendations, others]);

  // console.log(posts);

  const headlineText = "RAISING 2004";

  const handleShowBlog = (postId) => {
    const postData = allPosts.find((post) => post.id === postId);
    console.log(posts);
    console.log(postData);
    const trueSections = Object.entries(postData?.section || {})
      .filter(([key, value]) => value === true)
      .map(([key]) => key);

    const trueSectionsString =
      trueSections.length === 1 ? trueSections[0] : trueSections.join(", ");
    console.log(trueSectionsString);

    navigate(`/postlist`, {
      state: { trueSectionsString: trueSectionsString },
    });
  };

  // 画面幅に応じた文字数を設定
  useEffect(() => {
    // 画面幅に応じた文字数を設定
    const updateMaxChars = () => {
      if (window.innerWidth < 576) {
        setMaxChars(30); // 画面幅400px未満なら5文字
      } else if (window.innerWidth < 768) {
        setMaxChars(40); // 画面幅768px未満なら8文字
      } else if (window.innerWidth < 1400) {
        setMaxChars(50); // 画面幅768px未満なら8文字
      } else {
        setMaxChars(60); // それ以上なら10文字
      }
    };

    updateMaxChars(); // 初回実行
    window.addEventListener("resize", updateMaxChars); // リサイズ時に更新

    return () => {
      window.removeEventListener("resize", updateMaxChars); // クリーンアップ
    };
  }, []);

  const combinedText = (postTitle, postContent, maxChars) => {
    const text = postTitle + "：" + postContent;
    return text.length > maxChars
      ? postContent.slice(0, maxChars) + "..."
      : postContent;
  };

  return (
    <>
      <div
        className="home_container"
        style={{
          backgroundImage: `url(${displayImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          height: "100vh",
        }}
      >
        <div className="home_container_top">
          <div className="honoka headline">
            <div className={`honoka text ${isActive ? "is-active" : ""}`}>
              {headlineText.split("").map((char, index) => (
                <span
                  className={`honoka char ${char === " " ? "whitespace" : ""}`}
                  style={{ "--char-index": index }}
                  key={index}
                >
                  {char}
                </span>
              ))}
            </div>

            <div className="home-text"></div>
          </div>
          <div className="home-image-container">
            <div className="images-pa"></div>
          </div>
        </div>
        <div className="home_container_main">
          <div className="home_content_left">
            <div className="home_content_left_inner">
              {" "}
              <div
                className="home_content_left_title"
                onClick={() => navigate("./circleinfo")}
              >
                会の歩み
              </div>
              <div className="home_content_left_title">
                会員の戦歴（工事中）
              </div>
              <div className="home_content_left_title">会の？？（工事中）</div>
              <div className="home_content_left_title">
                会の？？戦歴（工事中）
              </div>
            </div>
          </div>{" "}
          <div className="home_content_center">
            {" "}
            <div className="home_content_inner">
              <div className="home_field">
                <div className="home_field_event_report">
                  <div className="home_field_event_title_event_report">
                    <span className="home_field_event_title_text">
                      イベント関係
                    </span>
                  </div>
                  {eventReports.map((post, index) => (
                    <table key={post.id || index} className="home_post_table">
                      <tbody>
                        <tr
                          onClick={() => {
                            handleShowBlog(post.id);
                          }}
                        >
                          <td className="home_post_title">
                            <span className="home_post_title_text">
                              {post.title} 　
                            </span>
                          </td>
                          <td className="home_post_title2">
                            {" "}
                            <span
                              className="home_post_content_text"
                              onClick={() => {
                                handleShowBlog(post.id);
                              }}
                            >
                              {combinedText(post.title, post.content, maxChars)}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ))}
                </div>

                <div className="home_field_event_member_exchange">
                  <div className="home_field_event_title_member_exchange">
                    <span className="home_field_event_title_text">
                      会の情報
                    </span>
                  </div>
                  {memberExchanges.map((post, index) => (
                    <table key={post.id || index} className="home_post_table">
                      <tbody>
                        <tr
                          onClick={() => {
                            handleShowBlog(post.id);
                          }}
                        >
                          <td className="home_post_title">
                            <span className="home_post_title_text">
                              {post.title} 　
                            </span>
                          </td>
                          <td className="home_post_title2">
                            <span
                              className="home_post_content_text"
                              onClick={() => {
                                handleShowBlog(post.id);
                              }}
                            >
                              {combinedText(post.title, post.content, maxChars)}{" "}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ))}
                </div>

                <div className="home_field_event_recommendations">
                  <div className="home_field_event_title_recommendations">
                    <span className="home_field_event_title_text">
                      テニス情報
                    </span>
                  </div>
                  {recommendations.map((post, index) => (
                    <table key={post.id || index} className="home_post_table">
                      <tbody>
                        <tr onClick={() => handleShowBlog(post.id)}>
                          <td className="home_post_title">
                            <span className="home_post_title_text">
                              {post.title}
                            </span>
                          </td>
                          <td className="home_post_title2">
                            <span
                              className="home_post_content_text"
                              onClick={() => {
                                handleShowBlog(post.id);
                              }}
                            >
                              {combinedText(post.title, post.content, maxChars)}{" "}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ))}
                </div>

                <div className="home_field_event_others">
                  <div className="home_field_event_title_others">
                    <span className="home_field_event_title_text">
                      よもやま話
                    </span>
                  </div>
                  {others.map((post, index) => (
                    <table key={post.id || index} className="home_post_table">
                      <tbody>
                        <tr>
                          <td
                            className="home_post_title"
                            onClick={() => {
                              handleShowBlog(post.id);
                            }}
                          >
                            <span className="home_post_title_text">
                              {post.title}
                            </span>
                          </td>
                          <td className="home_post_title2">
                            {" "}
                            <span
                              className="home_post_content_text"
                              onClick={() => {
                                handleShowBlog(post.id);
                              }}
                            >
                              {combinedText(post.title, post.content, maxChars)}
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  ))}
                </div>
              </div>
            </div>{" "}
          </div>
          <div className="home_content_right">
            {" "}
            <div className="home_content_right_top">
              {" "}
              <div className="home_content_right_top">
                <div className="custom_calendar_wrapper">
                  <div className="calendar_custom_container">
                    <Calendar />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="home_content_right_under">
              <h4>工事中です</h4>
            </div> */}
          </div>
        </div>

        <div className="home_content">
          <div></div>
        </div>
      </div>
      {/* <div className="home_container_bottom">
        <h4>工事中です</h4>
      </div> */}
    </>
  );
};

export default Home;
